'use client';

import React, { ReactNode } from 'react';

import {
  ThemeProvider as NextThemesProvider,
  type ThemeProviderProps,
} from 'next-themes';

interface CustomThemeProviderProps extends ThemeProviderProps {
  children: ReactNode;
}

// next-themes는 서버에서 children을 그대로 렌더하고, 테마는 인라인 스크립트가
// 페인트 전에 적용한다. mounted 가드로 SSR을 통째로 막으면 본문이 크롤러에
// 노출되지 않으므로 제거한다. 하이드레이션 경고는 <html suppressHydrationWarning>로 처리.
const ThemeProvider: React.FC<CustomThemeProviderProps> = ({
  children,
  ...props
}) => {
  return <NextThemesProvider {...props}>{children}</NextThemesProvider>;
};

export default ThemeProvider;
